import { render, staticRenderFns } from "./Bus.vue?vue&type=template&id=304e017e&"
import script from "./Bus.vue?vue&type=script&lang=js&"
export * from "./Bus.vue?vue&type=script&lang=js&"
import style0 from "./Bus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports